import { CouponModalIds, ReviewedCart } from "@swiggy-private/cart-types";

export const getNoFeeWeekendCouponData = (cartResponse: ReviewedCart | null) => {
    return cartResponse?.data?.no_fee_campaign_data || null;
};

export const isNoFeeWeekendCouponActive = (enabledOverlayId: string) =>
    enabledOverlayId === CouponModalIds.NO_FEE_WEEKEND_POPUP;

export const getNoFeeWeekendFrequencyCapping = (cartResponse: ReviewedCart | null) => {
    return cartResponse?.data?.no_fee_campaign_data?.popup_comms?.frequency_cap ?? 0;
};
